export default __webpack_public_path__ + "static/media/Virtual_hover_pen.10fcf2aa.png";